import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles(() => ({
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "27px",
    color: "#465869",
  },
  gridForm: {
    marginTop: "0px !important",
  },
  gridConditions: {
    marginTop: "3px !important",
  },
  containerConditions: {
    display: "flex",
    flexDirection: "column",
    marginTop: "15px",
  },
  subTitle: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "24px",
    color: getBrandCustom("primaryColor", "#308CDB"),
  },
  noConditions: {
    color: "#9CA6AF",
  },
  separator: {
    width: "100%",
    backgroundColor: "#E4E7EC",
    height: "1px",
    marginTop: "15px",
  },
}));

export default styles;
